import { ParticipantStatusEnum } from "enums/ParticipantStatusEnum";
import { NumberChoiceModel } from "models/ChoiceModel";
import { TranslationsContextProps } from "providers";

export function getParticipantStatuses(i18n: TranslationsContextProps): NumberChoiceModel[] {
  return [
    {
      value: ParticipantStatusEnum.Unknown,
      name: ParticipantStatusEnum[ParticipantStatusEnum.Unknown],
      text: i18n.ParticipantStatus_Unknown,
      tooltip: "",
      disabled: false,
      isDefault: false,
    },
    {
      value: ParticipantStatusEnum.Present,
      name: ParticipantStatusEnum[ParticipantStatusEnum.Present],
      text: i18n.ParticipantStatus_Present,
      tooltip: "",
      disabled: false,
      isDefault: true,
    },
    {
      value: ParticipantStatusEnum.Excused,
      name: ParticipantStatusEnum[ParticipantStatusEnum.Excused],
      text: i18n.ParticipantStatus_Excused,
      tooltip: "",
      disabled: false,
      isDefault: false,
    },
    {
      value: ParticipantStatusEnum.Unexcused,
      name: ParticipantStatusEnum[ParticipantStatusEnum.Unexcused],
      text: i18n.ParticipantStatus_Unexcused,
      tooltip: "",
      disabled: false,
      isDefault: false,
    },
    {
      value: ParticipantStatusEnum.Deleted,
      name: ParticipantStatusEnum[ParticipantStatusEnum.Deleted],
      text: i18n.ParticipantStatus_Deleted,
      tooltip: "",
      disabled: false,
      isDefault: false,
    },
  ];
}
